(() => {
  const initialiseHeader = (header) => {
    if (!header || header.dataset.alInitialised === 'true') return;

    const toggle = header.querySelector('[data-al-menu-toggle]');
    const closeButton = header.querySelector('[data-al-menu-close]');
    const navigation = header.querySelector('[data-al-navigation]');
    const navigationDetails = Array.from(header.querySelectorAll('.al-navigation__details'));
    const desktopNavigation = window.matchMedia('(min-width: 901px)');

    const closeNavigationDetails = (exception) => {
      navigationDetails.forEach((details) => {
        if (details !== exception) details.open = false;
      });
    };

    const closeMenu = () => {
      header.classList.remove('is-open');
      toggle?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('al-menu-open');
      closeNavigationDetails();
    };

    const openMenu = () => {
      header.classList.add('is-open');
      toggle?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('al-menu-open');
      closeButton?.focus();
    };

    toggle?.addEventListener('click', () => {
      if (header.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    closeButton?.addEventListener('click', closeMenu);
    navigation?.addEventListener('click', (event) => {
      if (event.target.closest('a')) closeMenu();
    });

    navigationDetails.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (details.open) closeNavigationDetails(details);
      });

      details.addEventListener('focusout', (event) => {
        if (!desktopNavigation.matches || details.contains(event.relatedTarget)) return;
        details.open = false;
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });

    document.addEventListener('click', (event) => {
      if (desktopNavigation.matches && !event.target.closest('.al-navigation__details')) {
        closeNavigationDetails();
      }
      if (
        header.classList.contains('is-open') &&
        !navigation?.contains(event.target) &&
        !toggle?.contains(event.target)
      ) {
        closeMenu();
      }
    });

    const updateScrollState = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 56);
    };

    window.addEventListener('scroll', updateScrollState, { passive: true });
    updateScrollState();
    header.dataset.alInitialised = 'true';
  };

  const initialiseAll = (root = document) => {
    root.querySelectorAll('[data-al-header]').forEach(initialiseHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
